import React from "react";
import { RotaButton } from "@teamrota/rota-design";
import Modal from "~/src/components/modal";
import ModalContent from "~/src/containers/modals/components/modal-content";
import { StyledModalBody, StyledModalFooter } from "./styles";
import { useBannerForm } from "./hooks/use-banner-form";
import BannerFormFields from "./banner-form-fields";

const BannerFormModal = ({ banner, onClose, onSuccess, isOpen }) => {
  const {
    formData,
    loading,
    isEdit,
    handleChange,
    handlePlatformChange,
    handleSubmit
  } = useBannerForm(banner, onSuccess);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent title={isEdit ? "Edit Banner" : "Create New Banner"}>
        <form onSubmit={handleSubmit}>
          <StyledModalBody>
            <BannerFormFields
              formData={formData}
              handleChange={handleChange}
              handlePlatformChange={handlePlatformChange}
            />
          </StyledModalBody>

          <StyledModalFooter>
            <RotaButton variant="secondary" onClick={onClose}>
              Cancel
            </RotaButton>
            <RotaButton type="submit" disabled={loading}>
              {loading
                ? "Saving..."
                : isEdit
                ? "Update Banner"
                : "Create Banner"}
            </RotaButton>
          </StyledModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default BannerFormModal;
